import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';
import { ApiInterfaceService } from './api-interface.service';

type UserFeedBackInputType = {
  attributes: {
    response: string;
    feedback?: string;
  };
};

@Injectable({
  providedIn: 'root',
})
export class UserFeedbackService {
  constructor(private api: ApiInterfaceService) {}

  /**
   * request to store user feedback.
   *
   * @param UserFeedBackInputType - Contains feedback message and type negative/positive.
   */

  async storeUserFeedback(UserFeedBackInput: UserFeedBackInputType): Promise<string> {
    try {
      const res = await this.api.gqlMutation(
        gql`
          mutation ($input: CreateMobileRatingPromptInput!) {
            createMobileRatingPrompt(input: $input) {
              mobileRatingPrompt {
                id
              }
            }
          }
        `,
        {
          input: UserFeedBackInput,
        },
      );
      return res['createMobileRatingPrompt']['mobileRatingPrompt']['id'];
    } catch (e) {
      return Promise.reject(e);
    }
  }

  /**
   * request to show mobile rating prompt to user.
   *
   * @param UserFeedBackInputType - Contains feedback message and type negative/positive.
   */

  async canShowMobileRatingPrompt(): Promise<boolean> {
    try {
      const res = await this.api.gqlMutation(gql`
        query userFeedbackRatingPrompt {
          qualifiesForMobileRatingPrompt {
            allowRating
          }
        }
      `);

      return res['qualifiesForMobileRatingPrompt']['allowRating'];
    } catch (e) {
      return Promise.reject(e);
    }
  }
}
